<template>
  <section class="userSteps">
      <Header />
    <div class="ContentBlock">
      <div class="d-flex justify-content-end padSpace" @click="store.clearMessage" v-if="store.error.msg">
        <button type="button" class="close_btn">
          <vue-feather size="26" type="x"></vue-feather>
        </button>
      </div>
      <div class="messageBlock" v-if="store.error.msg">
        <p class="alert" :class="(store.error.type == 'error') ? 'alert-danger' : 'alert-success'">{{store.error.msg}}</p>
      </div>
      <Form class="inputForm" @submit="submit">
        <div class="text-center mainTitle mb-md-5 mb-4">
          <h3 class="mb-3">{{$t('create_password.text1')}}</h3>
          <p>{{$t('create_password.text2')}}</p>
        </div>
        <float-label class="form-group">
          <div class="position-relative iconInput">
            <Field
              :type="inputtype"
              class="form-control"
              autofill="off"
              name="password"
              v-model="form.password"
              rules="required|min:2"
              :placeholder="$t('create_password.text3')"
              autocomplete="password"
            />
            <ErrorMessage class="text-danger" name="password" />
            <vue-feather class="position-absolute eye pointer"  :type="iconType" size="23" @click="switchVisibility"></vue-feather>
          </div>
          <!-- <p class="f-10 d-flex align-items-center">{{$t('create_password.text4')}}<vue-feather class="mx-1" type="alert-circle" size="12"></vue-feather> <span class="barPass"></span></p> -->
          <div class="toolMob d-flex align-items-center justify-content-end" :class="(!validPassword && form.password) ? 'orange' : (validPassword && form.password) ? 'green' : ''">
            <p class="f-10 mb-0">{{$t('view_register.text3')}}</p>
            <div class="tooltipbutton w-auto">
                <span class="tooltiptext">
                    <div class="strenghtPassword m-0">
                        <ul class="passwordStrenth mb-0">
                            <li :class="(upperCaseOk) ? 'green' : 'red'">{{$t('view_register.text4')}}</li>
                            <li :class="(form.password.length >= 8) ? 'green' : 'red'">{{$t('view_register.text5')}}</li>
                            <li :class="(numberOk) ? 'green' : 'red'">{{$t('view_register.text6')}}</li>
                            <li :class="(letterOk) ? 'green' : 'red'">{{$t('view_register.text7')}}</li>
                            <li :class="(SpecialCharOk) ? 'green' : 'red'">{{$t('view_register.text8')}}</li>
                        </ul>
                    </div>
                </span>
                <vue-feather class="mx-1 alertType" :type="(!validPassword && form.password) ? 'alert-circle' : (validPassword && form.password) ? 'check-circle' : 'alert-circle'" size="18"></vue-feather>
            </div>
            <span class="barPass"></span>
      </div>
        </float-label>
        <float-label class="form-group">
          <div class="position-relative iconInput">
            <Field
              :type="inputtype1"
              class="form-control"
              autofill="off"
              name="new password"
              v-model="form.newPassword"
              rules="required|confirmed:@password"
              :placeholder="$t('create_password.text3')"
              autocomplete="new-password"
            />
            <ErrorMessage class="text-danger" name="new password" />
            <vue-feather class="position-absolute eye pointer"  :type="iconType1" size="23" @click="switchVisibility1"></vue-feather>
          </div>
        </float-label>
        <div class="buttonElement mb-3">
          <a class="grd_btn full_size disabled" v-if="!validPassword">{{$t('create_password.text5')}}</a>
          <button type="submit" class="grd_btn full_size" v-else>{{$t('create_password.text5')}}</button>
        </div>
      </Form>
    </div>
    <stepFooter />
  </section>
</template>

<script>
  import { useMainStore } from "@/store";
import FloatLabel from 'vue-float-label/components/FloatLabel'
import stepFooter from "../../components/shared/step_footer";
import { Form, Field, ErrorMessage } from "vee-validate";
export default {
  setup() {
    const store = useMainStore();
    return { store };
  },
  data() {
    return {
      form : {
        password : '',
        newPassword : '',
      },
      iconType: "eye-off",
      inputtype: "password",
      showpassword1 : false,
      iconType1 : 'eye-off',
      inputtype1 : 'password',
      showpassword : false,
      upperCaseOk : false,
      numberOk : false,
      SpecialCharOk : false,
      letterOk : '',
      validPassword : false,
    }
  },
  computed: {
    isActive () {
      return false
    }
  },
  components: {
    stepFooter,
    FloatLabel,
    Form,
    Field,
    ErrorMessage,
  },
  watch:{
    "form.password": function (val) {
        let upperCase = new RegExp("[A-Z]"),
        numbers = new RegExp("[0-9]"),
        letter = new RegExp("[A-Za-z]"),
        specialcharacter = new RegExp("[!,%,&,@,#,$,^,*,?,_,~,/]");
        if (val.match(upperCase)) {
            this.upperCaseOk = true
        }else{
            this.upperCaseOk = false
        }
        if(val.match(numbers)){
            this.numberOk = true
        }else{
            this.numberOk = false
        }
        if (val.match(letter)) {
            this.letterOk = true;
        } else {
            this.letterOk = false;
        }
        if (val.match(specialcharacter)) {
            this.SpecialCharOk = true;
        } else {
            this.SpecialCharOk = false;
        }
        if(this.upperCaseOk && this.numberOk && this.SpecialCharOk && val.length >= 8 && this.letterOk){
            this.validPassword = true
        }else{
            this.validPassword = false
        }

    },
  },
  methods:{
    switchVisibility() {
      this.showpassword = !this.showpassword;
      if (this.showpassword) {
        this.inputtype = "text";
        this.iconType = "eye";
      } else {
        this.inputtype = "password";
        this.iconType = "eye-off";
      }
    },
    switchVisibility1() {
        this.showpassword1 = !this.showpassword1
        if(this.showpassword1){
            this.inputtype1 = 'text'
            this.iconType1 = 'eye'
        }else{
            this.inputtype1 = 'password'
            this.iconType1 = 'eye-off'
        } 
    },
    submit(){
      if(this.$route.params.hash){
          let formData = {};
          formData['accessToken'] = this.$route.params.hash
          formData['newPassword'] = this.form.newPassword
          //formData['userIdentifier'] = this.store.customerDetail.email
          this.store.resetPassword(formData,true)
        }
      }
  }
}
</script>